import { HttpClient } from '@angular/common/http';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Facturacion } from 'src/app/Models/facturacion';
import { Poliza } from 'src/app/Models/poliza';
import * as FileSaver from 'file-saver';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';

@Component({
  selector: 'app-detalle-poliza',
  templateUrl: './detalle-poliza.component.html',
  styleUrls: ['./detalle-poliza.component.css']
})
export class DetallePolizaComponent implements OnInit {
  @Input()
  poliza: Poliza;
  @Input()
  facturacion: Facturacion;
  asegurado: Asegurado;
  seguro: Seguro;
  constructor(private inj: Injector) {
   }

  ngOnInit(): void{
  }

  logPolicyDownload(): void{
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Descarga de pdf poliza: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);
  }
}
